import classNames from 'classnames';
import React from 'react';
import Transition from '../../components/Transition/Transition';
import './FieldFooter.scss';
import IFieldFooterProps from './FieldFooterProps';

const FieldFooter = ({ hasError, errorMessage, className }: IFieldFooterProps) => (
  <Transition transitionName="field-footer-anim" isOpen={hasError} speedOut={500}>
    <div className={classNames('field-footer-error', className)}>{errorMessage}</div>
  </Transition>
);

export default FieldFooter;
